// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notInQueue__uPWppU2rFC{color:var(--dixa-color-neutral-500)}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationTable/components/rows/conversationRow/components/rowCells/queue/conversationsTableQueue.module.scss"],"names":[],"mappings":"AAEA,wBACE,mCAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.notInQueue {\n  color: var(--dixa-color-neutral-500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notInQueue": `notInQueue__uPWppU2rFC`
};
export default ___CSS_LOADER_EXPORT___;
